export const RoleKeys = {
    paging: "getRolePaging",
    delete: "deleteRole",
    get: "getRoleById",
    create: "createRole",
    update: "updateRoleById",
    getUserMapping: "getRoleUserMapping",
    addUserMapping: "addRoleUserMapping",
    deleteUserMapping: "deleteRoleUserMapping",
    getApplicationMapping: "getRoleApplicationMapping",
    addApplicationMapping: "addRoleApplicationMapping",
    deleteApplicationMapping: "deleteRoleApplicationMapping",
    getModuleMapping: "getRoleModuleMapping",
    addModuleMapping: "addRoleModuleMapping",
    deleteModuleMapping: "deleteRoleModuleMapping",
    getFeatureMapping: "getRoleFeatureMapping",
    addFeatureMapping: "addRoleFeatureMapping",
    deleteFeatureMapping: "deleteRoleFeatureMapping",
    notInUsers: 'roleNotInUsers',
    notInModules: 'roleNotInModules',
    notInApplication: 'roleNotInApplications',
    notInFeatures: 'roleNotInFeatures',
}